import React, { useContext, useRef, useEffect } from 'react'
import cx from 'classnames'

import { ActionsRefContext } from './CardActionRefContext'
import { CardActionProps } from './interfaces'

import cm from './Card.module.css'

export const CardAction = ({ className, children, ...rest }: CardActionProps) => {
  const { register, unregister } = useContext(ActionsRefContext)
  const innerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = innerRef.current
    if (!el) return
    register(el)
    return () => {
      unregister(el)
    }
  }, [register, unregister])

  return (
    <div ref={innerRef} className={cx(cm.actionCard, className)} {...rest}>
      {children}
    </div>
  )
}
